import React from 'react';
import './AttendanceStatus.css';

function AttendanceStatus({ summary }) {
  const totals = summary?.totals || {};
  const stats = {
    present: totals.present || 0,
    absent: totals.absent || 0,
    sick: totals.sick || 0,
    late: totals.late || 0,
    vacation: totals.vacation || 0
  };
  const eligibleWorkdays = totals.eligibleWorkdays || 0;
  const plannedLeaveDays = totals.plannedLeaveDays || 0;
  const unplannedAbsenceDays = totals.unplannedAbsenceDays || 0;
  const atWorkDays = totals.atWorkDays || 0;
  const atWorkRate = eligibleWorkdays > 0 ? Number(summary?.atWorkRate || 0).toFixed(1) : '0.0';

  return (
    <div className="attendance-status">
      <h3>Attendance</h3>
      <div className="attendance-rate">
        <div className="rate-circle">
          <span className="rate-value">{atWorkRate}%</span>
          <span className="rate-label">At Work</span>
        </div>
      </div>
      <div className="attendance-stats">
        <div className="stat-item present">
          <span className="stat-label">Present</span>
          <span className="stat-number">{stats.present}</span>
        </div>
        <div className="stat-item late">
          <span className="stat-label">Late</span>
          <span className="stat-number">{stats.late}</span>
        </div>
        <div className="stat-item sick">
          <span className="stat-label">Sick</span>
          <span className="stat-number">{stats.sick}</span>
        </div>
        <div className="stat-item absent">
          <span className="stat-label">Absent</span>
          <span className="stat-number">{stats.absent}</span>
        </div>
      </div>
      <div className="attendance-details">
        <h4>Summary</h4>
        <ul>
          <li>
            <span className="badge present">Present</span>
            <span className="date">{stats.present} days</span>
          </li>
          <li>
            <span className="badge late">Late</span>
            <span className="date">{stats.late} days</span>
          </li>
          <li>
            <span className="badge sick">Sick</span>
            <span className="date">{stats.sick} days</span>
          </li>
          <li>
            <span className="badge absent">Absent</span>
            <span className="date">{stats.absent} days</span>
          </li>
          <li>
            <span className="badge vacation">Vacation</span>
            <span className="date">{stats.vacation} days</span>
          </li>
          <li>
            <span className="badge present">Eligible</span>
            <span className="date">{eligibleWorkdays} days</span>
          </li>
          <li>
            <span className="badge vacation">Planned Leave</span>
            <span className="date">{plannedLeaveDays} days</span>
          </li>
          <li>
            <span className="badge absent">Unplanned Absence</span>
            <span className="date">{unplannedAbsenceDays} days</span>
          </li>
          <li>
            <span className="badge present">At Work</span>
            <span className="date">{atWorkDays} days</span>
          </li>
          {eligibleWorkdays === 0 && <li>No attendance summary is available for this period.</li>}
        </ul>
      </div>
    </div>
  );
}

export default AttendanceStatus;
